import {
  FETCH_TRANSACTIONS,
  PUSH_TRANSACTIONS,
  UPDATE_TRANSACTIONS,
  REMOVE_TRANSACTIONS,
 } from '../actions/transactionsActions';

const INITIAL_STATE = {
  data: [],
}

export default function transactionsReducer(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        data:action.data,
      }
    case PUSH_TRANSACTIONS:
      return {
        ...state,
        data:[action.data, ...state.data],
      }
    case UPDATE_TRANSACTIONS:
      let updated = state.data.map((v)=>{
        if(v._id === action.data._id) {
          return action.data
        } else return v
      })
      return {
        ...state,
        data: updated
      }
    case REMOVE_TRANSACTIONS:
      return {
        ...state,
        data: [...state.data.filter( (item) => item._id !== action.data._id)]
      }
    default:
      return state

  }
}